import { render, staticRenderFns } from "./DeviationsBEStatistics.vue?vue&type=template&id=1c8ab166&"
import script from "./DeviationsBEStatistics.vue?vue&type=script&lang=js&"
export * from "./DeviationsBEStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports